<template>
  <div class="songpage">
    <slide></slide>
    <div class="row">
      <div class="songpageleft col-md-8 float-left pl-0">
        <category @categoryCodeToParent="categoryCode = $event"></category>
        <tab-tag :categoryCodeToChild = "categoryCode"></tab-tag>
      </div>

      <div class="songpageright col-md-4 float-right pr-0">
        <music-top></music-top>
        <p class="pt-2"></p>
        <bxh-ringbacktone></bxh-ringbacktone>
      </div>
      <div class="parent expand" style="clear: both"></div>
    </div>

    <div class="row">
      <partner></partner>
    </div>
  </div>
</template>

<script>
  import Slide from '../../home/web/Slide'
  import RingbacktoneTop from '../../home/web/RingbacktoneTop'
  import MusicTop from '../../home/web/MusicTop'
  import Category from './Category'
  import Tab from './Tab'
  import Partner from '../../home/web/Partner'
  export default {
    name: "Song",
    components: {
      "slide": Slide,
      'bxh-ringbacktone': RingbacktoneTop,
      'music-top': MusicTop,
      'category': Category,
      'tab-tag': Tab,
      'partner': Partner
    },
    data () {
      return {
        categoryCode: ""
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/song/web/Song.vue